<template>
  <Modal v-model="isVisible" footer-hide width="450" @on-cancel="closeModal">
    <Row class="d-flex flex-direction-column justify-center align-center gap-4">
      <Icon
          class="pe-4 ps-4"
          color="#F0AC19"
          size="100"
          type="md-warning"
      ></Icon>
      <span class="font-Regular-20">{{ $t("exchange.disClaimerModal.title") }}</span>
      <p class="text-center" style="margin-top: 20px">
        {{ $t("exchange.disClaimerModal.description") }}
      </p>
      <Button
          style="margin-top: 100px"
          class="font-Regular-12 text-white fill-width"
          @click="handleConfirm"
      >
        {{ $t("exchange.disClaimerModal.confirm") }}
      </Button>
      <Button
          style="margin-top: 10px"
          class="font-Regular-12 text-white fill-width"
          @click="closeModal"
      >
        {{ $t("exchange.disClaimerModal.cancel") }}
      </Button>
    </Row>
  </Modal>
</template>

<script>
export default {
  name: 'DisClaimerModal',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  methods: {
    handleConfirm() {
      this.$emit('confirm');
      this.closeModal();
    },
    closeModal() {
      this.isVisible = false
    }
  }
};
</script>
